import { CheckCircle2 } from 'lucide-react';
import { motion } from "framer-motion";

const benefits = [
"Estudar no tempo e ritmo",
"Se apresentar com segurança",
"Entender conversas do dia a dia",
"Participar de reuniões básicas",
"Viajar sem depender de tradutor",
"Ter base sólida para evoluir"];


function PromiseSection() {
  return (
    <section className="relative bg-white py-14 sm:py-20 px-4 overflow-hidden">
      {/* Subtle map watermark */}
      <div className="absolute inset-0 opacity-[0.02] bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48Y2lyY2xlIGN4PSI1MCIgY3k9IjUwIiByPSI0MCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMDAwIiBzdHJva2Utd2lkdGg9IjEiLz48Y2lyY2xlIGN4PSIxNTAiIGN5PSIxNTAiIHI9IjMwIiBmaWxsPSJub25lIiBzdHJva2U9IiMwMDAiIHN0cm9rZS13aWR0aD0iMSIvPjwvc3ZnPg==')] bg-repeat" aria-hidden="true" />

      <div className="max-w-5xl mx-auto relative z-10">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-2xl sm:text-3xl md:text-4xl font-bold text-center text-gray-900 mb-10">Com o EW Pass você pode:


        </motion.h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-10">
          {benefits.map((benefit, i) =>
          <motion.div
            key={i}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.4, delay: i * 0.1 }}
            className="flex items-start gap-3 bg-blue-50 rounded-xl p-4 border border-blue-100">

              <CheckCircle2 className="w-6 h-6 text-blue-600 flex-shrink-0 mt-0.5" />
              <span className="text-gray-800 font-medium">{benefit}</span>
            </motion.div>
          )}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.4 }}
          className="text-center space-y-2 mb-8">

          <p className="text-gray-700 text-lg">Não é promessa vazia de fluência em 30 dias.</p>
          <p className="text-gray-900 font-bold text-lg">
            É um plano estruturado para tirar você do básico de verdade.
          </p>
          <p className="text-gray-600">Com constância, estrutura e método, o resultado vem.</p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.5 }}
          className="text-center">

          <a
            href="#cta-final"
            className="inline-block bg-blue-600 text-white font-extrabold text-lg px-8 py-4 rounded-xl hover:bg-blue-700 transition-colors animate-pulse-glow-blue">

            👉 Quero viver essa transformação
          </a>
        </motion.div>
      </div>
    </section>);

}

export default PromiseSection;